import { APP_HEADER_CONSTANT } from '../constants/AppHeaderConstant';

const initialState = {
};

const AppHeaderReducer = (state = initialState, action) => {
    switch (action.type) {
        case APP_HEADER_CONSTANT.INIT_HEADER:
            return {
                ...state,
                headerData: {
                    loaded: true
                }
            }
        case APP_HEADER_CONSTANT.SHOW_OUTLOOK_MENU:
            return {
                ...state,
                headerData: {
                    ...state.headerData,
                    outlookMenuAnchor: action.anchor
                }
            }
        case APP_HEADER_CONSTANT.HIDE_OUTLOOK_MENU:
            return {
                ...state,
                headerData: {
                    ...state.headerData,
                    outlookMenuAnchor: undefined
                }
            }
        default:
            return state;
    }
};

export default AppHeaderReducer;